<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Subheader :title="`${assetListId ? 'Edit' : 'Add New'} Asset List`" />
    <div class="container">
      <div class="row py-3">
        <div class="col-md-3">
          <div class="form-group">
            <label for="assetListId" class="custom-label">ID</label>
            <input id="assetListId" type="text" class="form-control shadow-none custom-input"
              placeholder="This is autogenerated" readonly v-model="saveData.id">
          </div>
        </div>
        <div class="col-md-9 mb-3">
          <div class="form-group">
            <label for="assetTypeName" class="custom-label">Title</label>
            <input id="assetTypeName" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.title">
          </div>
        </div>
        <div class="col-md-12">

          <div class="form-check form-check-inline mb-2">
            <input class="form-check-input shadow-none" type="checkbox" name="inlineRadioOptions" id="inlineRadio2"
              v-model="saveData.iscatalogenable">
            <label class="form-check-label custom-label" for="inlineRadio2">Catalog Enable</label>
          </div>
          <div class="col-md-12 mb-3">
            <div class="form-group">
              <label for="assetTypeName" class="custom-label">Catalog</label>
              <input id="assetTypeName" class="form-control shadow-none custom-input" placeholder="Enter text"
                v-model="saveData.catalog">
            </div>
          </div>
        </div>

        <div class="col-md-3 ">
          <div class="form-check form-check-inline mb-2">
            <input class="form-check-input shadow-none" type="checkbox" name="inlineRadioOptions" id="inlineRadio1"
              v-model="saveData.isassetentry">
            <label class="form-check-label custom-label" for="inlineRadio1">Asset Entry</label>
          </div>
          <!-- <div class="form-group mb-3">
              <label class="custom-label">Asset</label>
              <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect" v-model="saveData.assetid">
                <option v-for="asset in assets" :key="asset.uuid" :value="asset.uuid">{{ asset.name }}</option>
              </select>
            </div> -->
        </div>
        <div class="row align-items-center">
          <div class="col-md-3 mb-3">
            <div class="form-group">
              <label class="custom-label">Asset</label>
              <div class="custom-multiple-dropdown-wrapper">
                <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
                  v-model="saveData.assetid">
                  <option value="" disabled selected>Select Option</option> <!-- Placeholder option -->
                  <option v-for="asset in assets" :key="asset.uuid" :value="asset.uuid">{{ asset.name }}</option>
                </select>
                <button @click="updateSelectedAsset(saveData.assetid)" class="multiple-dropdown-add-button">+</button>
              </div>
            </div>
          </div>

          <div class="col-md-9 mb-3 align-self-end custom-input">
            <div v-if="selectedAssets.length > 0" class="custom-multiple-dropdown-container">
              <div v-for="(asset, index) in selectedAssets" :key="index">
                <span class="custom-multiple-dropdown">{{ asset }}
                  <button class="multiple-dropdown-delete-icon" @click="removeSelectedAsset(index)">
                    <dropdownDeleteIcon />
                  </button>
                </span>
              </div>
            </div>
          </div>
          <small v-if="selectedAssets.length === 0" class="text-danger"
            style="margin-top: -10px; font-size: 11px;">Select asset</small>

        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeDesc" class="custom-label">Description</label>
            <input id="assetTypeDesc" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.description">
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeNote" class="custom-label">Notes</label>
            <textarea id="assetTypeNote" class="form-control shadow-none custom-input" placeholder="Enter text" rows="4"
              v-model="saveData.note"></textarea>
          </div>
        </div>
        <div class="col-md-3" v-if="this.assetListId">
          <div class="form-group">
            <button type="button" class="btn btn-danger btn-sm delete-button" data-bs-toggle="modal"
              data-bs-target="#exampleModal">Delete</button>
          </div>
        </div>
        <deleteModal v-if="this.assetListId" :deleteRecord="deleteRecord" />
        <div class="col-md-8 d-flex justify-content-end" v-if="this.assetListId">

          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-11 d-flex justify-content-end" v-else>
          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-1 d-flex justify-content-start">
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-sm submit-button" :disabled="isSubmitDisabled"
              @click="addAssetListData()">Submit</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Subheader from '@/components/Subheader.vue'
import { addAssetList, getByIdAssetList, updateAssetList } from '@/http/iot-asset/asset-list.http'
import { ddAsset } from '@/http/iot-asset/asset.http'
import deleteModal from '@/components/delete-modal.vue';
import dropdownDeleteIcon from '@/components/dropdown-delete-icon.vue';
export default {
  name: 'asset-list-form',
  components: {
    Header,
    Subheader,
    deleteModal,
    dropdownDeleteIcon
  },
  data() {
    return {
      breadcrumsfirst: "IoT Assets",
      breadcrumslast: "Asset List",
      assetListId: this.$route.params.id,
      saveData: {
        assetid: ''
      },
      assets: [],
      selectedAssets: [],
    }
  },
  mounted() {
    this.getAssetDropdownData()
      .then(() => {
        return this.getDetailData();
      })
      .catch(error => {
        console.error('Error mounting component:', error);
      });

  },
  computed: {
    isSubmitDisabled() {
      return this.selectedAssets.length === 0;
    }
  },

  methods: {
    addAssetListData() {
      if (this.assetListId) {
        const payload = {
          uuid: this.$route.params.id,
          iscatalogenable: this.saveData.iscatalogenable ? 1 : 0,
          isassetentry: this.saveData.isassetentry ? 1 : 0
        };
        const selectedAssetIds = this.selectedAssets.map(assetName => {
          const asset = this.assets.find(asset => asset.name === assetName);
          return asset ? asset.uuid : null;
        }).filter(Boolean).join(',');

        // Assign selected asset type IDs to saveData
        this.saveData.assetid = selectedAssetIds;
        updateAssetList({ ...this.saveData, ...payload }).then(() => {
          this.saveData.updatedon = new Date().toISOString();
          this.$router.push("/iotassets/assetlist");
        }).catch((error) => {
          this.error = error.message;
        });
      } else {
        const payload = {
          iscatalogenable: this.saveData.iscatalogenable ? 1 : 0,
          isassetentry: this.saveData.isassetentry ? 1 : 0
        };
        const selectedAssetIds = this.selectedAssets.map(assetName => {
          const asset = this.assets.find(asset => asset.name === assetName);
          return asset ? asset.uuid : null;
        }).filter(Boolean).join(',');

        // Assign selected asset type IDs to saveData
        this.saveData.assetid = selectedAssetIds;
        addAssetList({ ...this.saveData, ...payload }).then(() => {
          this.$router.push("/iotassets/assetlist")
        }).catch((error) => {
          this.error = error.message;
        });
      }

    },
    updateSelectedAsset(assetId) {
      const asset = this.assets.find(asset => asset.uuid === assetId);
      if (asset && !this.selectedAssets.includes(asset.name)) {
        this.selectedAssets.push(asset.name);
      }
    },
    removeSelectedAsset(index) {
      this.selectedAssets.splice(index, 1);

    },
    async getAssetDropdownData() {
      try {
        this.assets = await ddAsset();
      } catch (error) {
        console.error('Error fetching asset :', error);
        throw error;
      }
    },

    async getDetailData() {
      try {
        if (this.assetListId) {
          const response = await getByIdAssetList(this.assetListId);
          this.saveData = response;

          this.saveData = {
            ...response,
            iscatalogenable: !!response.iscatalogenable, // Convert to boolean
            isassetentry: !!response.isassetentry // Convert to boolean
          };
          if (Array.isArray(response.assetid) && response.assetid.length > 0) {
            this.selectedAssets = response.assetid.map(assetId => {
              const asset = this.assets.find(type => type.uuid === assetId);
              return asset ? asset.name : '';
            });
            this.saveData.assetid = '';
          } else {
            this.saveData.assetid = '';
          }
        }
      } catch (error) {
        console.error('Error fetching asset list details:', error);
        throw error;
      }
    },

    cancelButton() {
      this.$router.push("/iotassets/assetlist")
    },
    deleteRecord() {
      if (this.assetListId) {
        this.saveData.issoftdelete = 1;
        const payload = {
          issoftdelete: this.saveData.issoftdelete ? 1 : 0,
          uuid: this.$route.params.id,
          id: this.saveData.id,
          name: this.saveData.name,
          description: this.saveData.description,
          note: this.saveData.note,
          updatedon: this.saveData.updatedon,
          iscatalogenable: this.saveData.iscatalogenable ? 1 : 0,
          isassetentry: this.saveData.isassetentry ? 1 : 0,
          catalog: this.saveData.catalog,
          assetid: this.saveData.assetid
        };
        const selectedAssetIds = this.selectedAssets.map(assetName => {
          const asset = this.assets.find(asset => asset.name === assetName);
          return asset ? asset.uuid : null;
        }).filter(Boolean).join(',');

        // Assign selected asset type IDs to saveData
        this.saveData.assetid = selectedAssetIds;
        updateAssetList(payload)
          .then(() => {
            this.saveData.updatedon = new Date().toISOString();
            this.$router.push("/iotassets/assetlist");
          })
          .catch(error => {
            console.error('Error deleting record:', error);
          });
      }
    },
  }
}
</script>

<style scoped></style>